module.exports = __webpack_public_path__ + "static/media/pokemon_logo.3b84f84b.png";